var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-container full-view",class:!_vm.isClient ? 'pcweb' : ''},[(_vm.init)?[(_vm.pcIsDggj)?_c('dggj-header'):_vm._e(),(!_vm.pcIsDggj)?_c('auth-header'):_vm._e(),_c('router-view'),_c('update-dialog'),_c('login-view'),_c('context-menu')]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }